import axios from 'axios';
import { push } from 'react-router-redux';
import { I18n } from 'react-redux-i18n';

// Actions.
import * as AuthActions from 'actions/AuthActions';
import * as AlertAction from 'actions/AlertActions';

// Constants.
import * as ProfileConstants from 'constants/ProfileConstants';
import * as ErrorConstants from 'constants/ErrorConstants';

function requestLoadUserProfile() {
  return {
    type: ProfileConstants.LOAD_PROFILE_REQUEST,
  };
}

function receiveLoadUserProfile(profile) {
  return {
    type: ProfileConstants.LOAD_PROFILE_SUCCESS,
    profile,
  };
}

function receiveLoadUserProfileError(response) {
  return {
    type: ErrorConstants.LOAD_REQUEST_FAILURE,
    response,
  };
}

function receiveLoadUserProfileError1(response) {
  return {
    type: ProfileConstants.LOAD_PROFILE_FAILURE,
    response,
  };
}

export function loadUserProfile(cb) {
  return (dispatch, getState) => {
    dispatch(requestLoadUserProfile());
    const { auth } = getState();
    axios({
      method: 'GET',
      url: '/dashboard_api/v1/user/profile/',
    })
      .then((response) => {
        if (!auth.isAuthenticated) {
          dispatch(AuthActions.logout());
        }
        else {
          const profile = response.data;
          dispatch(receiveLoadUserProfile(profile));
          if (typeof cb === 'function') {
            cb(profile);
          }
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 403) {
            dispatch(receiveLoadUserProfileError1());
            // dispatch(push({ pathname: '/user/login' }));
          }
          else {
            dispatch(receiveLoadUserProfileError(error.response));
            // dispatch(push({ pathname: '/error' }));
          }
        }
      });
  };
}

function requestUpdateUserProfile(profile) {
  return {
    type: ProfileConstants.UPDATE_PROFILE_REQUEST,
    profile: profile,
  };
}

function receiveUpdatedUserProfile(profile) {
  return {
    type: ProfileConstants.UPDATE_PROFILE_SUCCESS,
    profile: profile
  };
}

export function updateUserProfile(data = {}) {
  return (dispatch, getState) => {
    let { profile: { profile } } = getState();
    profile = { ...profile, ...data };
    dispatch(requestUpdateUserProfile(profile));
    axios.put('/dashboard_api/v1/user/profile/', data)
      .then((response) => {
        dispatch(receiveUpdatedUserProfile(profile));
        // dispatch(loadUserProfile());
        const alertMessage = I18n.t('Изменения сохранены');
        dispatch(AlertAction.sendAlertMessage(alertMessage));
      })
      .catch((error) => {
      });
  };
}

export function uploadUserProfilePhoto(formData, userpic) {
  return (dispatch, getState) => {
    const { profile: { profile } } = getState();
    dispatch(requestUpdateUserProfile(profile));
    axios.post('/dashboard_api/v1/user/profile/userpic/upload/', formData , { headers: { "Content-Type": "multipart/form-data" } })
      .then((response) => {
        dispatch(receiveUpdatedUserProfile({
          ...profile,
          userpic: response.data.url
        }));
        // dispatch(loadUserProfile());
        const alertMessage = I18n.t('Изменения сохранены');
        dispatch(AlertAction.sendAlertMessage(alertMessage));
      })
      .catch((error) => {
      });
  };
}

export function deleteUserAccount(redirectURL) {
  return (dispatch) => {
    axios.post('/dashboard_api/v1/user/delete/')
      .then((response) => {
        if (!redirectURL) {
          dispatch(AuthActions.logout(isRedirect, redirectURL));
          return;
        }

        window.location.href = `${window.location.origin}${redirectURL}`;
      })
      .catch((error) => {
        const isRedirect = true;
        dispatch(AuthActions.logout(isRedirect, redirectURL));
      });
  };
}
